import i18n from "i18n"
import { connect } from "react-redux"
import { withNamespaces } from "react-i18next"
import { reduxForm } from "redux-form/immutable"
import { resetPassword } from "QuorumGrassroots/framework/action-creators"
import ResetPasswordPage from "QuorumGrassroots/framework/components/Foundations/ResetPasswordPage"
import { withRouter } from "QuorumGrassroots/withRouter"

export const validate = (immutableValues) => {
    const errors = {}
    const values = immutableValues.toJS()

    if (values.password && values.passwordConfirm && values.password !== values.passwordConfirm) {
        errors.passwordConfirm = i18n.t("registration.password.reset.do_not_match")
    }

    return errors
}

const mapStateToProps = (state) => {
    const userdata = state.framework.get("userdata")
    const params = new URLSearchParams(window.location.search)
    const isInitialResetPassword = params.get("is_initial_reset_password") === "true"
    const isCollaboratorSupporter = userdata?.get
        ? userdata.get("is_collaborator_supporter")
        : userdata?.is_collaborator_supporter

    return {
        isCollaboratorInitialReset: isCollaboratorSupporter && isInitialResetPassword,
    }
}

const submit = (values, dispatch, props) => {
    return dispatch(resetPassword(values, props))
}

const form = reduxForm({
    form: "reset_password",
    onSubmit: submit,
    validate,
})(withRouter(ResetPasswordPage))

export default connect(mapStateToProps)(withNamespaces()(form))
